export const fetchQueryTemplate = async (dashboardID: string, queryID: string) => {
  const template = await fetch(`/sql/${dashboardID}/${queryID}.sql`);
  return template.text();
};

export const fetchFilterTemplate = async (path: string) => {
  const template = await fetch(path);
  return template.text();
};
